const topics = [
  { name: '91免费在线视频', heat: '9.8万', hot: true },
  { name: '91免费视频网站', heat: '8.5万', hot: true },
  { name: '91福利在线视频', heat: '7.2万', hot: true },
  { name: '免费视频在线观看', heat: '6.9万', hot: false },
  { name: '在线免费视频网站', heat: '6.3万', hot: false },
  { name: '免费高清视频在线', heat: '5.8万', hot: true },
  { name: '91在线观看视频', heat: '5.4万', hot: false },
  { name: '91福利视频在线', heat: '4.9万', hot: false },
  { name: '高清视频推荐', heat: '4.6万', hot: false },
  { name: '热门专题精选', heat: '4.2万', hot: true },
];

export default function SectionTopics() {
  return (
    <section id="topics" className="bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 text-center mb-2">热门话题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">全网热搜话题标签，发现91麻豆免费视频网站最火内容</p>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((t, i) => (
            <a
              key={i}
              href="#index"
              className={`group relative inline-flex items-center gap-2 px-5 py-2.5 rounded-full cursor-pointer transition-all duration-200 ${
                t.hot
                  ? 'bg-primary-500 text-white hover:bg-primary-600 shadow-lg shadow-primary-500/20'
                  : 'bg-background-50 text-foreground-700 hover:text-primary-600 hover:bg-primary-50 border border-background-200'
              }`}
            >
              {t.hot && <i className="ri-fire-line text-sm"></i>}
              <span className="text-sm font-medium whitespace-nowrap">{t.name}</span>
              <span className={`text-xs ${t.hot ? 'text-white/75' : 'text-foreground-500'}`}>{t.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}